var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7337_5368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69824 10.1333L10.5 9.99996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 10.1336L4.22537 16.91C4.1431 16.9406 4.05379 16.9469 3.96804 16.9282C3.88229 16.9094 3.80372 16.8665 3.74167 16.8045C3.67961 16.7424 3.63667 16.6638 3.61796 16.5781C3.59925 16.4923 3.60555 16.403 3.63611 16.3208L5.69851 10.1336L3.63611 3.94638C3.60555 3.86411 3.59925 3.7748 3.61796 3.68905C3.63667 3.60331 3.67961 3.52474 3.74167 3.46268C3.80372 3.40062 3.88229 3.35769 3.96804 3.33898C4.05378 3.32026 4.1431 3.32656 4.22537 3.35713L18.6621 10.1336Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7337_5368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.88b9a90bba00a37e218625a7d52b99cf.svg";
export { ForwardRef as ReactComponent };